import { useState } from "react";
import { useAuth } from "../lib/auth";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Toaster } from "../components/ui/sonner";
import { Terminal } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const [u, setU] = useState(""); const [e, setE] = useState(""); const [p, setP] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (ev) => {
    ev.preventDefault();
    setLoading(true);
    try {
      await register(u, e, p);
      toast.success("Registered. Welcome aboard.");
      nav("/characters");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative">
      <div className="crt-overlay" />
      <div className="w-full max-w-md p-10 panel">
        <div className="flex items-center gap-2 amber amber-glow heading-mono text-2xl mb-1">
          <Terminal size={24} strokeWidth={1.5} /> NEW CREW RECORD
        </div>
        <div className="mono text-[10px] text-[#4AF626] tracking-[0.25em] uppercase mb-8">
          // Register biometric profile
        </div>
        <form onSubmit={submit} className="space-y-5">
          <div><div className="label-term mb-2">Callsign / Username</div>
            <input data-testid="register-username" className="input-term" value={u} onChange={(ev) => setU(ev.target.value)} required /></div>
          <div><div className="label-term mb-2">Email</div>
            <input data-testid="register-email" type="email" className="input-term" value={e} onChange={(ev) => setE(ev.target.value)} required /></div>
          <div><div className="label-term mb-2">Password</div>
            <input data-testid="register-password" type="password" className="input-term" value={p} onChange={(ev) => setP(ev.target.value)} required /></div>
          <button data-testid="register-submit" className="btn-amber w-full" disabled={loading}>
            {loading ? "Processing..." : "> Enroll"}
          </button>
        </form>
        <div className="mt-6 mono text-xs text-[#A0A0A0] text-center">
          Existing crew? <Link to="/login" className="amber hover:underline" data-testid="nav-login">Authenticate</Link>
        </div>
      </div>
      <Toaster theme="dark" />
    </div>
  );
}
